


export const DIRECT_SALES_ORDER = {
    BASE_PATH: '/direct-sale-order/sale-order/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    CONVERT_TO_INVOICE_PATH(id: string | number) {
        return this.BASE_PATH + `${id}` + '/edit/convert-to-invoice';
    },
    ADD_BUTTON_TITLE: 'Add New Direct Sale Order',
    ADD_NEW_TITLE: 'Add New Direct Sale Order',

    ADD_PAGE_TITLE: 'Add New Direct Sale Order',
    LIST_PAGE_TITLE: 'Direct Sale Order List',
    EDIT_PAGE_TITLE: 'Edit Direct Sale Order',
    GET_ALL: 'direct-sale-order/sale-order',
    GET_ALL_APPROVAL: 'direct-sale-order/sale-order-approval',
    GET_ONE: 'direct-sale-order/sale-order/edit/',
    CREATE: 'direct-sale-order/sale-order',
    UPDATE: 'direct-sale-order/sale-order/update/',
    DELETE: 'direct-sale-order/sale-order/delete/',
    APPROVE: 'direct-sale-order/order-approval/update/',
};





